export default __webpack_public_path__ + "static/media/icons8-multicultural_people.d8b3fa86.svg";